/** "Does buy now, pay later for flights affect your credit score?": metadata (the article is in ../bodies/does-buy-now-pay-later-affect-credit-score.js). */
export default {
  slug: 'does-buy-now-pay-later-affect-credit-score',
  category: 'Pay over time',
  title: 'Does buy now, pay later for flights affect your credit score?',
  seoTitle: 'Does Buy Now, Pay Later Affect Your Credit Score?',
  description: 'Can Affirm, Klarna, Afterpay, PayPal or Uplift hurt your credit when you book a flight? What each reports, soft vs hard checks, FICO BNPL scores and late payments.',
  dek: 'Most pay-later lenders check your eligibility without touching your score, but what they report afterward varies a lot. Here is what each major provider reports, how the new FICO scores treat it, what happened to the CFPB’s rule, and how to protect your credit.',
  author: 'Stephanie Ludwig',
  published: '2026-11-03',
  updated: '2026-11-03',
  faqs: [
    {
      q: 'Does checking my eligibility for Affirm or Klarna hurt my credit score?',
      a: 'No. Affirm says checking for plans won’t affect your credit, and Klarna says its soft checks for Pay in 4, Pay in 30 days and Pay over time don’t affect your score. What is reported after you accept a plan is a separate question.',
    },
    {
      q: 'Does Affirm report to credit bureaus?',
      a: 'Yes. Affirm says all payment activity on its loans, including Pay in 4, has been reported to Experian since April 1, 2025, and plans started on or after May 1, 2025 are also reported to TransUnion.',
    },
    {
      q: 'Does Afterpay affect your credit score?',
      a: 'Afterpay says it does not currently report to credit bureaus in the United States. It may run a soft check when new customers sign up, and it runs a credit check for its Pay Monthly option.',
    },
    {
      q: 'Do on-time buy now, pay later payments build credit?',
      a: 'Not reliably yet. Affirm said in 2025 that its newly reported loans wouldn’t be factored into traditional credit scores in the near term, and FICO’s BNPL-inclusive scores depend on lenders choosing to use them.',
    },
    {
      q: 'How long does a late buy now, pay later payment stay on my credit report?',
      a: 'If a late payment is reported, the CFPB says negative payment history can generally stay on your credit report for up to seven years. Flex Pay, for example, reports payments that are more than 30 days late.',
    },
    {
      q: 'Does Defera report to the credit bureaus?',
      a: 'No. Defera doesn’t run a credit check and doesn’t report your payment plan or on-time payments to the credit bureaus, so paying on time with Defera won’t help build your credit.',
    },
  ],
  related: [
    'book-flights-without-klarna-or-affirm',
    'missed-pay-later-payment-on-a-flight',
    'book-flights-with-bad-credit',
  ],
};
